export default "__VITE_ASSET__jZ9ieNIX__"